import { useMutation, useQueryClient } from "@tanstack/react-query";
import { showErrorAlert } from "../../utils/showErrorAlert";
import { showSuccessToast } from "../../utils/showToastAlert";

async function deleteCatalog({ callApi, id }) {
  if (!id) throw new Error("Missing dataset-offer id");

  const url = `/dataset-offers/${id}`;
  const res = await callApi(url, { method: "DELETE" });

  const status =
    res?.statusCode ??
    res?.status ??
    res?.data?.statusCode ??
    res?.data?.status;

  if (typeof res?.ok === "boolean" && !res.ok) {
    const e = new Error(`Delete failed (${status ?? "unknown"})`);
    e.statusCode = status;
    e.response = res;
    throw e;
  }

  if (status && status >= 400) {
    const e = new Error(`Delete failed (${status})`);
    e.statusCode = status;
    e.response = res;
    throw e;
  }

  return res;
}

export function useDeleteCatalog({ callApiWithWorker, t }) {
  const qc = useQueryClient();

  return useMutation({
    mutationKey: ["deleteCatalog"],
    mutationFn: ({ id }) => deleteCatalog({ callApi: callApiWithWorker, id }),

    onSuccess: async () => {
      showSuccessToast(t?.("common.deleteSuccessMessage") || "Deleted successfully", {
        title: t?.("common.deleteSuccessTitle") || "Deleted!",
      });
      qc.invalidateQueries({ queryKey: ["datasetOffers"] });
    },

    onError: (err) => {
      showErrorAlert(err, t);
    },
  });
}
